export default "__VITE_ASSET__3cd751ae__"